import { useState } from 'react';

import { CalendarIcon } from '@assets/icons';
import { DateType } from '@utils/dateUtil';
import ResponsiveSearchDrawerItem from '@components/views/components/listing/drawer/ResponsiveSearchDrawerItem';
import ResponsiveApplyButton from '@components/views/components/listing/drawer/ResponsiveApplyButton/ResponsiveApplyButton';
import ResponsiveSearchInputDrawer from '@components/views/components/listing/drawer/ResponsiveSearchInputDrawer/ResponsiveSearchInputDrawer';
import { FlightSearchInputDrawerType } from '@components/views/flight/types';
import ResponsiveDateRangePicker from '@components/DatePicker/DateRangePicker/ResponsiveDateRangePicker';
import { DayPickerRangeControllerProps } from '@components/DatePicker/DateRangePicker/DateRangePicker';

import {
  getDateRangePickerPlaceholder,
  isFlightReturnDateOutsideRange,
} from './utils';
import { ButtonWrapper } from './styled';

const searchLabel = 'Gidiş-Dönüş Tarihiniz?';

const ResponsiveDateRangeSelectDrawer = ({
  startDate,
  endDate,
  onDatesChange,
  title,
  subTitle,
  placeholder,
  drawerTitle,
  arrowIcon,
  inputComponent,
  isSubmit,
}: Pick<
  DayPickerRangeControllerProps,
  'startDate' | 'endDate' | 'onDatesChange'
> &
  FlightSearchInputDrawerType & {
    inputComponent:
      | 'shopAndFlyHomePageFlight'
      | 'shopAndFlyHomePageHotel'
      | 'setur';
  } & { isSubmit?: boolean }) => {
  const [focusedInput, setFocusedInput] =
    useState<DayPickerRangeControllerProps['focusedInput']>(null);
  return (
    <ResponsiveSearchInputDrawer
      icon={CalendarIcon}
      title={title}
      subTitle={subTitle}
      placeholder={placeholder}
      drawerTitle={drawerTitle}
      arrowIcon={arrowIcon}
      inputComponent={inputComponent}
      startDate={startDate}
      endDate={endDate}
      isSubmit={isSubmit}
      onFocusChange={setFocusedInput}
    >
      {(hideModal) => (
        <ResponsiveDateRangeSelect
          startDate={startDate}
          endDate={endDate}
          onDatesChange={onDatesChange}
          hideModal={hideModal}
          focusedInput={focusedInput}
        />
      )}
    </ResponsiveSearchInputDrawer>
  );
};

const ResponsiveDateRangeSelect = ({
  startDate,
  endDate,
  onDatesChange,
  hideModal,
  focusedInput,
}: Pick<
  DayPickerRangeControllerProps,
  'startDate' | 'endDate' | 'onDatesChange' | 'focusedInput'
> & {
  hideModal: () => void;
}) => {
  const [localStartDate, setLocalStartDate] = useState<DateType | null>(
    startDate
  );
  const [localEndDate, setLocalEndDate] = useState<DateType | null>(endDate);

  const handleDatesChange = ({
    startDate,
    endDate,
  }: {
    startDate: DateType | null;
    endDate: DateType | null;
  }) => {
    setLocalStartDate(startDate);
    setLocalEndDate(endDate);
  };

  const localSubTitle = getDateRangePickerPlaceholder(
    localStartDate,
    localEndDate
  );

  const onSubmit = () => {
    if (localStartDate && localEndDate) {
      onDatesChange({ startDate: localStartDate, endDate: localEndDate });
      hideModal();
    }
  };

  return (
    <>
      <ResponsiveSearchDrawerItem
        icon={CalendarIcon}
        title={searchLabel}
        subTitle={localSubTitle}
        placeholder='Gidiş - Dönüş Tarihleri'
      />

      <ResponsiveDateRangePicker
        minimumNights={0}
        startDate={localStartDate}
        endDate={localEndDate}
        onDatesChange={handleDatesChange}
        isOutsideRange={(day) =>
          isFlightReturnDateOutsideRange(day, localStartDate)
        }
        initialFocusedInput={focusedInput}
        isDynamicFocus
      />
      <ButtonWrapper>
        <ResponsiveApplyButton onClick={onSubmit} />
      </ButtonWrapper>
    </>
  );
};

export default ResponsiveDateRangeSelectDrawer;
